import { IModuleMenuItem } from './components/ModuleMenuItem/interfaces';

const STORAGE_KEY = 'module-switcher-usage';

export const MEMBER_PORTAL_MODULE_ID = 'member-portal';

export const MY_PROFILE_MODULE_ID = 'my-profile';

export const getModuleUsageCounts = (): Record<string, number> => {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);

    if (!raw) {
      return {};
    }

    const parsed: unknown = JSON.parse(raw);

    if (typeof parsed !== 'object' || parsed === null || Array.isArray(parsed)) {
      return {};
    }

    return Object.fromEntries(
      Object.entries(parsed).filter(
        (entry): entry is [string, number] => typeof entry[1] === 'number'
      )
    );
  } catch {
    return {};
  }
};

export const recordModuleUsage = (moduleId: string): void => {
  const counts = getModuleUsageCounts();
  counts[moduleId] = (counts[moduleId] ?? 0) + 1;
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(counts));
};

export const sortModulesByUsage = (
  moduleList: IModuleMenuItem[],
  usageCounts: Record<string, number>,
  defaultOrderById: Map<string, number>
): IModuleMenuItem[] => {
  const portal = moduleList.find(
    (module) => module.id === MEMBER_PORTAL_MODULE_ID
  );
  const myProfile = moduleList.find(
    (module) => module.id === MY_PROFILE_MODULE_ID
  );
  const middle = moduleList.filter(
    (module) =>
      module.id !== MEMBER_PORTAL_MODULE_ID &&
      module.id !== MY_PROFILE_MODULE_ID
  );

  const sortedMiddle = [...middle].sort((moduleA, moduleB) => {
    const usageDiff =
      (usageCounts[moduleB.id] ?? 0) - (usageCounts[moduleA.id] ?? 0);

    if (usageDiff !== 0) {
      return usageDiff;
    }

    return (
      (defaultOrderById.get(moduleA.id) ?? 0) -
      (defaultOrderById.get(moduleB.id) ?? 0)
    );
  });

  return [
    ...(portal ? [portal] : []),
    ...sortedMiddle,
    ...(myProfile ? [myProfile] : []),
  ];
};
